




























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Datepicker from 'vue2-datepicker';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import cart from '@/store/modules/cart';
import cms from '@/store/modules/cms';
import { Country, RegistrationRequest, Region, QuoteAddress, Gender } from '@/store/models';
import store from '@/store';
import Agreement from '@/components/Cms/Agreement.vue';
import { event as userRegisteredEvent } from '@/events/userRegistered';
import { findRegions } from '@/commons/regionFinder';
import { getDefaultCustomAttributes } from '@/commons/addressNormalizer';
import GmapAutocomplete from '@/components/Address/GmapAutocomplete.vue';
import { placeFoundCallback } from '@/commons/gmap';
import { i18n, datepickerLocales } from '@/i18n';
import { scrollToInput } from '@/commons/scrollto';
import IconChecklist from '@/components/SvgIcons/IconChecklist.vue';

@Component({
  components: {
    Agreement,
    Datepicker,
    GmapAutocomplete,
    IconChecklist,
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
})
export default class Registration extends Vue {
  @Prop() private fidelity!: boolean;

  private loading = false;
  private confirmpassword = '';
  private userData = {
    firstname: '',
    lastname: '',
    street: '',
    cap: '',
    city: '',
    country_id: store.state.options.country.default,
    email: '',
    password: '',
    telephone: '',
    gender: 0,
    dob: '',
    streetNumber: '',
    region: '',
    region_id: 0,
    countryCode: '',
    extraAddress: '',
  };

  private mounted() {
    this.userData.countryCode = store.state.options.countrysettings.telprefix;
    const stateRequiredFor = store.state.options.countrysettings.state_required;
    if (this.isRegionOptional && !stateRequiredFor) {
      this.userData.region = 'n/a';
    }
  }

  get dateFormat(): string {
    return store.state.options.dateFormat.toUpperCase();
  }

  get lang(): string {
    return datepickerLocales[store.state.options.locale];
  }

  get countries(): Country[] {
    return store.state.countryData.countries;
  }

  get telprefixes(): any[] {
    return store.state.options.telprefixes;
  }

  get coutryRegions() {
    return findRegions(this.userData.country_id);
  }

  get isRegionOptional(): boolean {
    return store.state.options.countrysettings.is_region_optional;
  }

  get postcodeValidationRule(): string {
    return store.getters.postcodeValidationRule;
  }

  get telephoneValidationRule() {
    const rule: any = { required: true };
    if (store.state.options.countrysettings.telephonedigits) {
      rule.digits = store.state.options.countrysettings.telephonedigits;
    }
    return rule;
  }

  get genders(): Gender[] {
    return store.state.options.user.gender.options;
  }

  get openDate() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return (this.userData.dob == null || this.userData.dob === '') ? date : '';
  }
  private disabledDobs(date: Date): boolean {
    const dateDob = new Date();
    dateDob.setFullYear(dateDob.getFullYear() - 18);
    return date > dateDob;
  }

  private placeFoundHandler(place: google.maps.places.PlaceResult) {
    const address = placeFoundCallback(place, this.buildAddress() as QuoteAddress);
    this.userData.street = address.street[0];
    this.userData.region_id = address.region_id;
    this.userData.cap = address.postcode;
    this.userData.city = address.city;
    const found = address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_street_number');
    if (found) {
      this.userData.streetNumber = found.value;
    }
  }

  private agreementExist(name: string): boolean {
    return cms.hasAgreements && cms.agreementByName(name) !== undefined;
  }

  private buildAddress() {
    const custAttrs: any = getDefaultCustomAttributes();
    custAttrs.find((att: any) => att.attribute_code === 'tdy_street_number').value = this.userData.streetNumber;
    custAttrs.find((att: any) => att.attribute_code === 'tdy_country_code').value = this.userData.countryCode;
    custAttrs.find((att: any) => att.attribute_code === 'tdy_extra_address').value = this.userData.extraAddress;

    const addr: any = {
      firstname: this.userData.firstname,
      lastname: this.userData.lastname,
      country_id: this.userData.country_id,
      telephone: this.userData.telephone,
      street: [this.userData.street],
      postcode: this.userData.cap,
      city: this.userData.city,
      default_billing: true,
      default_shipping: true,
      custom_attributes: custAttrs,
    };

    if (this.userData.region_id) {
      addr.region_id = this.userData.region_id;
    } else {
      addr.region = {
        region_code: this.userData.region,
        region: this.userData.region,
        region_id: 0,
      };
    }

    return addr;
  }

  private async register(data: any) {
    const valid = await this.$validator.validateAll();
    if (!valid) {
      if (this.$validator.errors.items.length > 0) {
        scrollToInput(this.$validator.errors.items[0].field);
      }
      return;
    }
    this.loading = true;

    const registrationReq = {
      user: {
        firstname: this.userData.firstname,
        lastname: this.userData.lastname,
        email: this.userData.email,
        gender: this.userData.gender,
        dob: Vue.filter('date')(this.userData.dob, 'Y-m-d'),
        website_id: store.state.options.website_id,
        addresses: [],
        // addresses: [this.buildAddress()],
        extension_attributes: {
          is_fidelity_registration: this.fidelity,
          approved_agreements: cms.approvedAgreementIds,
        },
      },
      password: this.userData.password,
    } as RegistrationRequest;

    try {
      const registrationRes = await user.register(registrationReq);
      const userLoginRes = await user.login({
        username: this.userData.email,
        password: this.userData.password,
        cartToken: cart.token,
      });
      this.$toast.success(i18n.t('Registration successful').toString());
      ui.closeSidebar();
      this.$emit('registrationsuccess', userLoginRes);
      this.$eventBus.$emit(userRegisteredEvent, {
        result: registrationRes,
        request: registrationReq,
        userToken: userLoginRes,
        isFidelity: this.fidelity,
      });

      if (cart.isCartGuestFlagSet) {
        this.$router.push({ path: '/' });
      }
      cart.flagLoading({key: 'registrationlogin', value: true});
      window.location.reload();
    } catch (e) {
      let errmess = i18n.t('Error during registration').toString();
      const error = e as unknown as any;
      if (error && error.response && error.response.data && error.response.data.message) {
        errmess += ' \n ' + error.response.data.message;
      }
      this.$toast.err(errmess);
      this.loading = false;
    }
  }
}
